if(typeof mv === 'undefined') { var e = new Error("Cannot find module 'mv'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = mv;